import React from 'react';
import Container from './components/UI/Container';
import LimitSetup from './components/LimitSetup';
import Simulation from './components/Simulation';
import { SimulatorProvider, useSimulator } from './context/SimulatorContext';

function AppContent() {
  const { state } = useSimulator();
  
  return (
    <Container>
      {state.showLimitSetup ? (
        <LimitSetup />
      ) : (
        <Simulation />
      )}
    </Container>
  );
}

export default function App() {
  return (
    <SimulatorProvider>
      <AppContent />
    </SimulatorProvider>
  );
} 